import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { DailyBalancesSection } from '@/features/ledger/daily-balances'

/**
 * The stored daily balance rollups, as an addressable screen of its own.
 *
 * Where somebody goes after a drift alarm names a row. Read-only and fine at any width.
 */
export function LedgerDailyBalancesPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Daily balances"
        description="The stored rollups the trial balance is built from: one row per account, per branch, per day. A drift check re-derives these from the postings and alarms where they disagree."
      />

      <DailyBalancesSection />
    </>
  )
}
